import "./price-range.ab617366.chunk.js";
import { G as GCarousel } from "./g-carousel.552b52b1.chunk.js";
import "./carouselManager.aac5e7bb.chunk.js";
class CollectionProductsCarousel extends GCarousel {
  constructor() {
    super();
    this.dynamic = true;
  }
  async fetchItems() {
    console.log("fetch items");
    const response = await fetch(this.url + `?section_id=ajax-collection-products-carousel&max_count=${this.maxCount}&default_product_state=${this.defaultProductState}`);
    const text = await response.text();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;
    const items = Array.from(tempDiv.querySelectorAll("#items .splide__slide")).map(
      (slide) => slide.outerHTML
    );
    if (items.length > 0) {
      this.splideList.innerHTML = items.join("");
      this.show();
    } else {
      this.hide();
    }
  }
  show() {
    this.setAttribute("aria-hidden", false);
  }
  hide() {
    this.setAttribute("aria-hidden", true);
  }
  get url() {
    return this.dataset.url;
  }
  get maxCount() {
    return Number(this.dataset.maxCount);
  }
  get defaultProductState() {
    return this.dataset.defaultProductState;
  }
}
customElements.define("collection-products-carousel", CollectionProductsCarousel);
class FilterList extends HTMLElement {
  constructor() {
    super();
    this.listEl = this.querySelector(".js-filter-list");
    this.listItemEls = this.listEl.querySelectorAll("li");
    this.searchInputEl = this.querySelector(".js-filter-search");
  }
  connectedCallback() {
    this._attachEventListeners();
  }
  _attachEventListeners() {
    var _a;
    (_a = this.searchInputEl) == null ? void 0 : _a.addEventListener("input", this._onSearchTextInput.bind(this));
  }
  _onSearchTextInput() {
    const filterText = this.searchInputEl.value.toLowerCase();
    this.listItemEls.forEach((item) => {
      const label = item.dataset.value.toLowerCase();
      item.style.display = label.includes(filterText) ? "" : "none";
    });
  }
}
customElements.define("filter-list", FilterList);
class CollectionNavMenu extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.dataset.lazyload === "true") {
      this._fetchMenu();
    }
  }
  async _fetchMenu() {
    const result = await fetch(window.location.pathname + `?sections=ajax-collection-side-menu&nav-item-handle=${this.dataset.navItemHandle}`);
    const json = await result.json();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = json[Object.keys(json)[0]];
    let menu;
    if (this.dataset.type === "desktop") {
      menu = tempDiv.querySelector("#desktop-menu");
    } else {
      menu = tempDiv.querySelector("#mobile-menu");
    }
    if (menu) {
      this.innerHTML = menu.innerHTML;
    } else {
      this.innerHTML = "";
    }
  }
}
customElements.define("collection-nav-menu", CollectionNavMenu);
//# sourceMappingURL=jc-bundle-collection.js.map
